import A from 'components/atoms/A/A';
import RegistrationCard from 'components/atoms/RegistrationCard/RegistrationCard';
import UsernameInput, { UsernameInputMode } from 'components/atoms/TextInput/UsernameInput';
import Form from 'components/molecules/Form/Form';
import React, { useState } from 'react';
import classes from './HeroEntryForm.module.scss';
import Txt from 'components/atoms/Txt/Txt';
import SocialSignUpButtons from 'components/organisms/RegistrationForm/SocialSignUpButtons';
import { checkUserExists } from 'components/templates/AuthenticationProvider/authApiUtils';
import { CONTACT_US, LOGIN, SIGN_UP } from 'components/pages/pages';
import { useRouter } from 'next/router';

export default function HeroEntryForm() {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  async function handleSubmit(formData: FormData) {
    const username = formData.get('username') as string;
    setIsLoading(true);
    try {
      const exists = await checkUserExists(username);
      const destination = exists ? LOGIN.path : SIGN_UP.path;
      router.push({ pathname: destination, query: { email: username } });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className={classes.registrationFormContainer}>
      <RegistrationCard
        title="Sign up and start earning"
        hasUppercaseTitle
        hasCenteredTitle
        hideTitleOnMobile
        className={classes.registrationCard}
      >
        <Txt components="p" className={classes.infoText}>
          It&apos;s quick and easy!
        </Txt>
        <Form
          submitDisabled={isLoading}
          alwaysEnableSubmit
          noValidate
          submitName={isLoading ? 'Checking...' : 'Continue'}
          submitButtonType="primary"
          onSubmit={handleSubmit}
          buttonWrapperClassName={classes.buttonWrapper}
        >
          <UsernameInput forceMode={UsernameInputMode.EMAIL} />
        </Form>
        {/* Temporarily removed until we get social sign in working */}
        {/* <SocialSignUpButtons hasTitle title="or continue via" /> */}
      </RegistrationCard>
    </div>
  );
}
